












import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["currentLinks", "today", "collectMessage"])
})
export default class NavMenu extends Vue {
    mounted() {
        this.getDate()
    }
    // 获取征期
    getDate() {
        Vue.axios
            .get(
                `collectionperiods/current?accounterNo=${this.$store.state.account.no}`)
            .then(res => {
                this.$store.dispatch("updateCollectMessage", res.data);
            });
    }
    clickMenu(link: App.Link) {
        this.getDate()
        this.$router.push(link.url);
    }

    getCurrentPath(path: string) {
        return this.$route.path === path
        this.getDate()
    }

    @Watch("$route")
    routeChanged() {
        this.getDate();
    }

}
